import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UsageRecordEditorRow, {
  type UsageRecordEditorRowData,
} from './UsageRecordEditorRow';
import { SampleFormSectionTitle } from './SampleFormSectionTitle';

interface SampleFormUsageHistorySectionProps {
  records: UsageRecordEditorRowData[];
  sampleCreatedDate: string;
  language: string;
  onAdd: () => void;
  onFieldChange: (index: number, field: string, value: unknown) => void;
  onRequestDelete: (index: number) => void;
}

/** サンプル編集モーダルの使用履歴テーブル */
export default function SampleFormUsageHistorySection({
  records,
  sampleCreatedDate,
  language,
  onAdd,
  onFieldChange,
  onRequestDelete,
}: SampleFormUsageHistorySectionProps) {
  const { t } = useTranslation();

  return (
    <div className="sample-form-section border-0 pt-1">
      <SampleFormSectionTitle
        icon="fa-history"
        trailing={
          <Button
            variant="primary"
            size="sm"
            type="button"
            onClick={onAdd}
            aria-label={t('common.add')}
            title={t('sample.add_usage_history_row_title', {
              defaultValue: '使用履歴の行を追加',
            })}
          >
            <i className="fas fa-plus me-1" aria-hidden="true" />
            {t('common.add')}
          </Button>
        }
      >
        {t('sample.usage_history')}
      </SampleFormSectionTitle>

      {records.length === 0 ? (
        <div className="text-center text-muted py-3">
          <i className="fas fa-inbox fa-2x mb-2" aria-hidden="true" />
          <p className="mb-0 small">{t('sample.no_usage_history')}</p>
        </div>
      ) : (
        <div className="table-responsive sample-form-usage-table">
          <Table striped bordered hover size="sm" className="mb-0">
            <thead className="table-light sticky-top">
              <tr>
                <th className="text-nowrap">{t('sample.usage_date')}</th>
                <th style={{ width: '12%' }}>{t('sample.action')}</th>
                <th style={{ width: '20%' }}>{t('sample.detail')}</th>
                <th style={{ width: '12%' }}>{t('sample.quantity_used')}</th>
                <th style={{ width: '12%' }}>{t('sample.remaining_quantity_label')}</th>
                <th style={{ width: '15%' }}>{t('sample.recorded_by')}</th>
                <th style={{ width: '14%' }}>{t('common.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record, index) => (
                <UsageRecordEditorRow
                  key={record.clientKey}
                  record={record}
                  index={index}
                  sampleCreatedDate={sampleCreatedDate}
                  language={language}
                  onFieldChange={onFieldChange}
                  onRequestDelete={onRequestDelete}
                />
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}
